import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initSentry, Sentry } from './lib/sentry';

// Initialise error tracking before anything else renders so that any
// exception during App mount is captured. No-op when REACT_APP_SENTRY_DSN
// isn't set (local dev) or when running on localhost.
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={({ resetError }) => (
      <div className="min-h-screen bg-stone-50 flex items-center justify-center px-4">
        <div className="bg-white rounded-2xl shadow-sm p-6 max-w-md text-center">
          <p className="text-3xl mb-2">⚠️</p>
          <p className="text-base font-bold text-stone-800 mb-2">Something went wrong</p>
          <p className="text-sm text-stone-600 leading-relaxed mb-4">
            We've been notified and will look into it. You can try refreshing the page or tapping the button below.
          </p>
          <button onClick={resetError}
            className="bg-teal-700 hover:bg-teal-800 text-white font-bold px-4 py-2 rounded-xl text-sm">
            Try again
          </button>
        </div>
      </div>
    )}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// Register service worker — makes this a true PWA on Android/iOS
// Without this, Chrome treats each home screen launch as a fresh session
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .catch(err => console.error('SW registration failed:', err))
  })
}
